
import { Vue } from "vue-class-component";

export default class LocationCheck extends Vue {}
